/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable arrow-parens */
/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  background: #090f35;

  div: {
    margin: 0 auto;
  }
`;

export const Notification = styled.button`
  background: none;
  border: 0;
  position: absolute;
  right: 8vh;
  top: 3vh;

  ${(props) =>
    props.hasUnread &&
    css`
      &::after {
        position: absolute;
        right: 2px;
        top: 2px;
        width: 12px;
        height: 12px;
        background: #ff0000;
        content: '';
        border-radius: 50%;
      }
    `}
`;

export const Modal = styled.div`
  z-index: 5;
  position: absolute;
  left: -150px;
  top: 55px;

  width: 200px;
  height: 300px;

  background: rgba(44, 51, 91, 1);
  border: 3px solid #36ded6;
  border-radius: 5px;

  color: #fff;
  padding: 15px;
  font-weight: bold;

  &::before {
    content: '';
    position: absolute;
    right: 12px;
    top: -23px;
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-bottom: 20px solid #36ded6;
  }
`;
